import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IHbManager } from './hb-manager';
import { HbParserService } from './hb-parser.service';
import { WsService2 } from '../ws/ws.service';
@Injectable()
export class HbManagerService implements IHbManager {
    constructor(private hbParser: HbParserService, private wsService: WsService2) {
        console.log("Creatnig hb manager service")
        hbParser.setHbManager(this);
        wsService.setHbManager(this);
    }
   
    watchServerHb() {
        console.log("Calling watch server hb")
        var self = this;
        if (this.serverHbHandler){
            try{
                clearInterval(this.serverHbHandler);
            }catch(err){console.error(err)}
        }
        this.serverHbHandler = setInterval(function () {

            var o = self.last + environment.hbCheckThreshold*environment.hbCheckInterval;
            var n = new Date().getTime()
            
            if (o < n) {//connection is gone
                console.log("Last hb came before "+(n-o)/1000 +" n: "+n+" o:"+o);
               self.last = n;
               clearInterval(self.serverHbHandler);
               self.hbClosed();
                 
            }
        }, environment.hbCheckInterval);
    }
    hbClosed(){
        console.log("HB is stale, will notify listeners");
        //self.hbParser.close();
        this.wsService.close();
       // this.wsService.connect();
    }
    connect() {
    //    this.wsService.close();
        this.wsService.init();
        this.wsService.connect();
    }
    watchMyHb() {
        
        var self = this;
          try{
                clearInterval(this.myHbHandler);
            }catch(err){console.error(err)}
  
        this.myHbHandler = setInterval(function () {
           
            self.hbParser.sendHb();
        }, environment.hbSendInterval);
    }
    serverHbHandler;
    last = new Date().getTime();
    onHb() {

        this.last = new Date().getTime();
    }
    myHbHandler;
    watchMe=false
    watchServer = false;
    onReady(watchServer=true, watcheMe=true){
        this.watchMe = watcheMe;
        this.watchServer = watchServer;
        this.connect();
        
    }
    onConnected() {
        console.log("Got connected in hb manager, there might has been a disconnection");
        if (this.watchMe)
            this.watchMyHb();
        if (this.watchServer)
            this.watchServerHb();
 }
    onDisconnected() {
        clearInterval(this.myHbHandler);
        
    }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/hb/hb-manager.service.ts